export const supersetBlockSchema = () => {
  return {
    title: 'Dashboard Superset',
    fieldsets: [
      {
        id: 'default',
        title: 'Padrão',
        fields: ['dashboard_id', 'height', 'align'], // 1. Adicionado 'align' aqui
      },
    ],
    properties: {
      dashboard_id: {
        title: 'ID do Dashboard',
        description: 'Cole o código UUID do painel gerado no Superset.',
        type: 'string',
      },
      height: {
        title: 'Altura (px)',
        description: 'Exemplo: 600, 1000, 1500. (O padrão é 800)',
        type: 'number',
        default: 800,
      },
      // 2. Adicionado a propriedade align com o widget correto
      align: {
        title: 'Alinhamento',
        widget: 'align',
        type: 'string',
      },
    },
    required: ['dashboard_id'],
  };
};
